import { render, staticRenderFns } from "./penjurusan.vue?vue&type=template&id=260d48a8&"
import script from "./penjurusan.vue?vue&type=script&lang=js&"
export * from "./penjurusan.vue?vue&type=script&lang=js&"
import style0 from "./penjurusan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports